module.exports = __webpack_public_path__ + "static/media/jessica-pereira.923184af.jpeg";